define("shared/utils/media-adjustments/has-persisted-record", ["exports", "@ember/object"], function (_exports, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.hasPersistedRecord = hasPersistedRecord;
  0; //eaimeta@70e063a35619d71f0,"@ember/object"eaimeta@70e063a35619d71f
  function hasPersistedRecord(record) {
    return Boolean(record.id) && !(0, _object.get)(record, 'isNew');
  }
});